import { DateTime } from "luxon"
import { LogError } from "../../helpers/logger"

export function formatDate(x) {
  let startDateKey = getDateKey(x.startDateTime)
  let endDateKey = getDateKey(x.endDateTime)

  if (x.timezone !== "" && x.timezone !== null) {
    if (x.startDateTime.includes("T")) {
      x.startDateTime = DateTime.fromISO(x.startDateTime, {
        zone: x.timezone,
      }).setZone(DateTime.local().toFormat("z")) // local conversion
      x.endDateTime = DateTime.fromISO(x.endDateTime, {
        zone: x.timezone,
      }).setZone(DateTime.local().toFormat("z")) // local conversion
      x.scheduledTime =
        x.startDateTime.toFormat("hh:mm a") +
        " - " +
        x.endDateTime.toFormat("hh:mm a")

      x.startDateTime = x.startDateTime.toISO()
      x.endDateTime = x.endDateTime.toISO()
    } 
    else {
      x.startDateTime = DateTime.fromFormat(x.startDateTime, startDateKey, {
        zone: x.timezone,
      }).setZone(DateTime.local().toFormat("z")) // local conversion
      x.endDateTime = DateTime.fromFormat(x.endDateTime, endDateKey, {
        zone: x.timezone,
      }).setZone(DateTime.local().toFormat("z")) // local conversion
      x.scheduledTime =
        x.startDateTime.toFormat("hh:mm a") +
        " - " +
        x.endDateTime.toFormat("hh:mm a")

      x.startDateTime = x.startDateTime.toISO()
      x.endDateTime = x.endDateTime.toISO()
    }
  } 
  else {
    x.scheduledTime =
      DateTime.fromFormat(
        x.startDateTime,
        getDateKey(x.startDateTime)
      ).toFormat("hh:mm a") +
      " - " +
      DateTime.fromFormat(x.endDateTime, getDateKey(x.endDateTime)).toFormat(
        "hh:mm a"
      )
  }
  return x
}

export const timezones = [
  { name: "Eastern Standard Time", code: "America/New_York" },
  { name: "Pacific Standard Time", code: "America/Los_Angeles" },
  { name: "Mountain Standard Time", code: "America/Phoenix" },
  { name: "Mountain Daylight Savings Time", code: "America/Denver" },
  { name: "Central Standard Time", code: "America/Chicago" },
  { name: "Hawaii/Aleutian Standard Time", code: "Pacific/Honolulu" },
  { name: "Alaskan Standard Time", code: "America/Anchorage" },
]

export const services = [
  "Intake",
  "Recovery Planning Session",
  "Brief Check-in",
  "Care Coordination Session",
  "Group Session",
  "Discharge Session",
]

export const durations = [
  { code: "15m", name: "15 minutes", mins: "15" },
  { code: "30m", name: "30 minutes", mins: "30" },
  { code: "45m", name: "45 minutes", mins: "45" },
  { code: "60m", name: "60 minutes", mins: "60" },
  { code: "90m", name: "90 minutes", mins: "90" },
  { code: "2h", name: "2 hours", mins: "120" },
  { code: "3h", name: "3 hours", mins: "180" },
  { code: "4h", name: "4 hours", mins: "240" },
  { code: "5h", name: "5 hours", mins: "300" },
  { code: "6h", name: "6 hours", mins: "360" },
  { code: "7h", name: "7 hours", mins: "420" },
  { code: "8h", name: "8 hours", mins: "480" },
]

export const engagementChannels = [
  "in-person",
  "telephone",
  "video",
  "text/app message",
  "email",
  "other",
]

export const groupFilterTemplate = [
  {
    label: "Appointment Type",
    code: "TYPE",
    items: [
      { label: "Intake", value: "Intake" },
      {
        label: "Recovery Planning Session",
        value: "Recovery Planning Session",
      },
      { label: "Brief Check-in", value: "Brief Check-in" },
      {
        label: "Care Coordination Session",
        value: "Care Coordination Session",
      },
      { label: "Group Session", value: "Group Session" },
      { label: "Discharge Session", value: "Discharge Session" },
    ],
  },
  {
    label: "Status",
    code: "STATUS",
    items: [
      { label: "Active", value: "Active" },
      { label: "Cancelled", value: "Cancelled" },
    ],
  },
  {
    label: "Appointment Channel",
    code: "JP",
    items: [
      { label: "In-Person", value: "in-person" },
      { label: "Telephone", value: "telephone" },
      { label: "Video", value: "video" },
      { label: "Text/App Message", value: "text/app message" },
      { label: "Email", value: "email" },
      { label: "Other", value: "other " },
    ],
  },
]

export const customStyles = {
  content: {
    width: "600px",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },

  inputField: {
    color: "#757575",
    fontFamily: "Lato,sans-serif",
    fontWeight: "700",
    fontSize: "16px",
    width: "45%",
  },
  inputStyle: { marginBottom: "10px", marginTop: "5px", width: "100%" },
}

export const isFormFieldValid = (activeAppointment, name) =>
  activeAppointment.errors[name]

export function checkValidWeeklyDateFromStart(
  isBiWeekly,
  LuxonControllerStartDate,
  luxonAppointmentDate
) {
  //If this is a biweekly appointment, isBiWeekly will be TRUE
  if (!isBiWeekly) {
    return true
  }

  //If the appointment date is before the start date, this is invalid.
  if (luxonAppointmentDate < LuxonControllerStartDate) {
    return false
  }

  //Get the start of the week for the dates
  const startDateStartOfWeek = LuxonControllerStartDate.startOf("week")
  const appointmentDateStartOfWeek = luxonAppointmentDate.startOf("week")

  //Calculate the weeks between the controller start date and appointment date.
  const dateDifference = appointmentDateStartOfWeek
    .diff(startDateStartOfWeek, "weeks")
    .toObject()

  //If the week calculator is less than one, it is in the same week.
  if (dateDifference.weeks < 1) {
    return true
  } else if (Math.floor(dateDifference.weeks) % 2 === 0) {
    return true
  } else {
    return false
  }
}

export function getDateKey(startDateTime, luxonFormat) {
  let dateKey = ""
  if (startDateTime.includes("/")) {
    dateKey = "MM/dd/yyyy hh:mm a"
  } else if (!startDateTime.includes("T")) {
    dateKey = "yyyy-MM-dd hh:mm a"
  }

  if (startDateTime.split(":").length === 4) {
    dateKey = dateKey.replace("hh:mm", "hh:mm:ss")
  }

  if (startDateTime.includes(" -") || startDateTime.includes(" +")) {
    dateKey += " ZZ"
  }

  if (luxonFormat) {
    dateKey = dateKey.replace("DD", "dd")
    dateKey = dateKey.replace("yyyy", "yyyy")
    dateKey = dateKey.replace("A", "a")
  }

  return dateKey
}

//convert a datestring into a Luxon DateTime object
export function getDate(dateString, luxonFormat) {
  const dateKey = getDateKey(dateString, luxonFormat)

  if (!!dateKey) {
    return DateTime.fromFormat(dateString, dateKey)
  } else {
    return DateTime.fromISO(dateString, { setZone: true })
  }
}

//Convert a datestring into a luxon DateTime object and force the timezone to the specified zone, keeping the time as is
export function getDateOverrideZone(dateString, luxonFormat, timezone) {
  let date = getDate(dateString, luxonFormat)

  return date.setZone(timezone, {
    keepLocalTime: true,
  })
}

export function getDateTimeValue(dateString, luxonFormat) {
  const dateKey = getDateKey(dateString, luxonFormat)

  //If no dateKey is found, assume that the string is in ISO format.
  return !!dateKey
    ? DateTime.fromFormat(dateString, dateKey)
    : DateTime.fromISO(dateString)
}

export function reformatAppointmentRequest(
  payload,
  participant,
  staff,
  organization,
) {

  let time =
    typeof payload.time == "object"
      ? DateTime.fromJSDate(payload.time).toFormat(
        "hh:mm a"
      )
      : payload.time

  const id = payload.isRecurringController
    ? `recurring_${payload.id}`
    : payload.id.toString()

  let formattedPayload = {
    id: id,
    caseId: participant.participant_alias,
    peerId: staff.staff_alias,
    staffName: staff.staff_name_first + " " + staff.staff_name_last,
    staffEmail: staff.staff_email_address,
    serviceName: payload.type,
    participantName: participant.participant_name_first + " " + participant.participant_name_last,
    participantEmail: participant.participant_email_account,
    participantPhone: participant.participant_phone_number,
    startDateTime:
      DateTime.fromJSDate(payload.startDate).toFormat(
        "MM/dd/yyyy"
      ) +
      " " +
      time,
    endDateTime: DateTime.fromFormat(
      DateTime.fromJSDate(payload.startDate).toFormat(
        "MM/dd/yyyy"
      ) +
      " " +
      time,
      "MM/dd/yyyy hh:mm a"
    )
      .plus({ minutes: parseInt(payload.duration.mins) })
      .toFormat("MM/dd/yyyy hh:mm a"),
    duration: payload.duration?.mins,
    engagementChannel: payload.channel,
    timezone: DateTime.local().toFormat("z"),
    orgId: organization.organization_alias,
    cron: payload.cron?.cronValue || null,
    isRecurring: payload.isRecurring,
    isRecurringController: payload.isRecurringController || false,
    recurringStartDate: DateTime
      .fromFormat(DateTime.fromJSDate(payload.startDate).toFormat("MM/dd/yyyy"), "MM/dd/yyyy")
      .toISO(),
    recurringEndDate: DateTime.fromJSDate(
      payload.endDate
    ).toISO(),
    alias: {
      orgAlias: organization.organization_id,
      staffAlias: staff.staff_id,
      participantAlias: participant.participant_id,
    },
    selectedPeriod: payload.cron?.period || null,
  }

  if (formattedPayload.isRecurring) {
    if (
      formattedPayload.recurringEndDate === undefined ||
      DateTime.fromJSDate(formattedPayload.recurringEndDate) <
      DateTime.fromJSDate(formattedPayload.recurringStartDate)
    ) {
      participant.setNotificationError(
        "You must select a valid end date for the recurring rules."
      )
      return
    }

    //Calculate the startDateTime and endDateTime based on RecurringStartDate and duration.
    //Staff client will calculate the first occurrence of this schedule.
    const selectedStartDate = DateTime.fromISO(formattedPayload.recurringStartDate)
    const selectedEndDate = DateTime.fromISO(formattedPayload.recurringEndDate)
    const selectedStartTime = DateTime.fromJSDate(
      payload.time
    ).setZone(payload.timezone?.code || formattedPayload.timezone)

    let startDateTime = DateTime.now()
      .set({
        day: selectedStartDate.day,
        month: selectedStartDate.month,
        year: selectedStartDate.year,
        hour: selectedStartTime.hour,
        minute: selectedStartTime.minute,
        second: 0,
        millisecond: 0,
      })
      .setZone(payload.timezone?.code || formattedPayload.timezone, {
        keepLocalTime: true,
      })

    let durationType =
      payload.duration.code[
      payload.duration.code.length - 1
      ]
    let duration = parseInt(payload.duration?.code)

    let momentsType
    if (durationType === "h") {
      momentsType = "hours"
    } else {
      momentsType = "minutes"
    }

    let plusObj = {}
    plusObj[momentsType] = duration

    let endDateTime = startDateTime.plus(plusObj)
    let recurringEndDateTime = DateTime.now()
      .set({
        day: selectedEndDate.day,
        month: selectedEndDate.month,
        year: selectedEndDate.year,
        hour: endDateTime.hour,
        minute: endDateTime.minute,
        second: 0,
        millisecond: 0,
      })
      .setZone(payload.timezone?.code || formattedPayload.timezone, {
        keepLocalTime: true,
      })

    formattedPayload.recurringStartDate = startDateTime.toISO()
    formattedPayload.startDateTime = startDateTime.toISO()
    formattedPayload.recurringEndDate = recurringEndDateTime.toISO()
    formattedPayload.endDateTime = endDateTime.toISO() //This is the endTime based on duration from startDateTime and not recurring endDateTime.
  }

  return formattedPayload
}

export function reformatFormikPayload(appointment, userCtx) {
  // Extract organization from user context
  const organization = userCtx.participant_organizations?.find(o => o.organization_alias === appointment.orgId) || null

  // Generate cron object
  const generateCron = () => {
    const cron = {
      cronDescription: undefined,
      cronValue: appointment.cron || null,
      generated: true,
      period: appointment.selectedPeriod || "Daily",
    }
    return cron
  }

  // Construct the payload
  const payload = {
    id: appointment.id || 0,
    organization: organization?.organization_id || null,
    staff: organization?.staff_assignment_list[0]?.staff_id || null, // Default to first staff member in the organization.
    isRecurring: appointment.isRecurring || appointment.isRecurringController || false,
    startDate: appointment.startDateTime ? new Date(appointment.startDateTime) : null,
    endDate: appointment.endDateTime ? new Date(appointment.endDateTime) : null,
    originalStartDateTime: appointment.originalStartDateTime || null,
    originalEndDateTime: appointment.originalEndDateTime || null,
    time: appointment.scheduledTime ? DateTime.fromFormat(appointment.scheduledTime.split(" - ")[0], "hh:mm a").toJSDate() : null, // Extract time from scheduledTime.
    duration: appointment.duration ? durations.find(d => d.mins === appointment.duration.toString()) : null,
    cron: generateCron(),
    type: appointment.engagementType || null,
    channel: appointment.engagementChannel || null,
  }

  // If the appointment is recurring, set the recurring dates.
  if (appointment.isRecurring) {
    payload.startDate = appointment.recurringStartDate ? new Date(appointment.recurringStartDate) : null
    payload.endDate = appointment.recurringEndDate ? new Date(appointment.recurringEndDate) : null
  }
  // If the appointment is a recurring controller, set the start and end dates.
  else if (appointment.isRecurringController) {
    payload.startDate = appointment.startDate ? new Date(appointment.startDate) : null
    payload.endDate = appointment.endDate ? new Date(appointment.endDate) : null
  }

  // If no duration is set, calculate it based on the scheduled time.
  if (!appointment.duration && appointment.scheduledTime) {
    const startTime = DateTime.fromFormat(appointment.scheduledTime.split(" - ")[0], "hh:mm a");
    const endTime = DateTime.fromFormat(appointment.scheduledTime.split(" - ")[1], "hh:mm a");
    const durationInMinutes = endTime.diff(startTime, 'minutes').minutes;
    payload.duration = durations.find(d => d.mins === durationInMinutes.toString()) || null; // Find the matching duration.
  }

  return payload
}

export const formatOrgCalDate = (rowData, fieldName = "startDateTime") => {
  return DateTime.fromISO(rowData[fieldName]).toFormat("MM/dd/yyyy")
}

export function getDaysArrayByMonth(dateIndex) {
  let daysInMonth = dateIndex.daysInMonth
  let arrDays = []

  while (daysInMonth) {
    let current = dateIndex.set({ day: daysInMonth })
    arrDays.push(current)
    daysInMonth--
  }

  return arrDays
}

export function getLocalControllerDescription(frequency, scheduledTime) {
  try {
    let localFrequency = frequency.split(" | ")
    localFrequency[2] = scheduledTime
    return localFrequency.join(" | ")
  } catch (error) {
    LogError("Unable to parse local controller description", error)
    return frequency
  }
}

export const requestModalModeOptions = {
  request: "Request Appointment",
  edit: "Edit Appointment Request",
  change: "Request Appointment Change",
  cancel: "Cancel Appointment/Controller"
}

export const calendarListTypes = {
  upcoming: "Upcoming",
  past: "Past",
  pending: "Pending",
  declined: "Declined"
}

export const pendingChangeTooltip = "You already have a pending change request for this appointment, you cannot request another change until the current one is resolved."
export const rescheduleCancellationTooltip = "You can't edit a '[TYPE]' request."

export const hasPendingChange = (appointment) => {
  return appointment.status === "BOOKED.PENDING_CHANGE"
}
